import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@flexibilitypay/shared';

import { ROUTES } from './routes-config';

export function ProtectedRoute() {
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  if (!isLoggedIn) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  return <Outlet />;
}
